import React from "react";
import "./EditButton.css";
import { useTranslation } from "react-i18next";

const EditButton = ({
  text = "Edit",
  color,
  backgroundColor,
  padding,
  onClick,
  animate = false,
}) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={onClick}
      className={`edit-button common-text ftw-4 ${
        padding ? "padding-cus" : ""
      } ${animate ? "edit-button-animate" : ""}`}
      style={{
        color: color || "#FFF",
        backgroundColor: backgroundColor || "#094C80",
        cursor: "pointer",
      }}
    >
      {t(text)}
    </div>
  );
};

export default EditButton;
